<template>
  <div class="container-info">
    <div class="img-info">
      <div
        @click="close"
        class="close"
      >
        <img
          :src="require('@/assets/icons/add.svg')"
          alt="close"
        >
      </div>
      <template v-if="loadMsg">
        <span class="msg">{{msg}}</span>
      </template>
      <span class="title">Link</span>
      <input
        type="text"
        :readonly="true"
        ref="link"
        :value="link"
        class="input-copy"
      />
      <button @click="copiarLink">Copy link</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'modal-link',
  props: {
    link: String,
  },
  data() {
    return {
      loadMsg: false,
      msg: 'Link copied to clipboard',
    };
  },
  methods: {
    close() {
      this.$emit('closeModalLink', false);
    },
    closeMsg() {
      setTimeout(() => {
        this.loadMsg = false;
      }, 3000);
    },
    async copiarLink() {
      try {
        const linkProva = await this.$refs.link;
        linkProva.select();
        document.execCommand('copy');
        this.loadMsg = true;
        this.closeMsg();
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>
<style lang="scss">
.title {
  font-weight: 500;
  font-size: 34px !important;
  letter-spacing: 0.274837px;
  color: $header;
}
.container-info {
  position: fixed;
  display: flex;
  align-items: center;
  z-index: 10;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(48, 48, 48, 0.5);
  .img-info {
    position: relative;
    padding: 100px 33px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    background-color: $white;
    width: 44.2vw;
    height: 90vh;
    border-radius: 10px;
    @media (max-width: 960px) {
      width: 100%;
      height: 100%;
      border-radius: 0px;
    }
    .close {
      position: absolute;
      right: 0;
      top: 0;
      padding: 20px;
      font-size: 30px;
      img {
        cursor: pointer;
        transform: rotate(45deg);
      }
    }
    button {
      margin: 0 auto;
      width: 330px;
      height: 46px;
      background: $primary;
      border-radius: 62px;
      outline: none;
      font-weight: bold;
      font-size: 20px;
      color: $white;
    }
    span {
      font-weight: 500;
      font-size: 24px;
      letter-spacing: 0.274837px;
      color: $black;
    }
  }
}
.input-copy {
  margin-top: -50px;
  display: flex;
  outline: none;
  height: 50px;
  padding: 13px 20px;
  box-shadow: 0px 0px 5.12821px rgba(0, 0, 0, 0.25);
  border-radius: 96.1538px;
  font-weight: 500;
  font-size: 19.2308px;
  letter-spacing: 0.352355px;
  color: #58c5c9;
}
.msg {
  position: absolute;
  font-size: 16px !important;
  top: 0;
  left: 0;
  right: 0;
  margin-top: 100px;
  color: $payed !important;
  z-index: 2 !important;
  &::after {
    content: "";
    position: absolute;
    width: 260px;
    height: 30px;
    background-color: $backgroundPayed;
    margin-left: -230px;
    margin-top: -3px;
    z-index: -1;
    border-radius: 96px;
  }
}
</style>
